import { render } from "./AddFeatures.vue?vue&type=template&id=1a8553fd&scoped=true"
import script from "./AddFeatures.vue?vue&type=script&lang=js"
export * from "./AddFeatures.vue?vue&type=script&lang=js"

import "./AddFeatures.vue?vue&type=style&index=0&id=1a8553fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8553fd"]])

export default __exports__